import BottomNav from './BottomNav'
import FAB from './FAB'
import Sidebar from './Sidebar'
import RightPanel from './RightPanel'
import BackGuard from './BackGuard'
import TrafficAlertBanner from './TrafficAlertBanner'

export default function Layout({ children }) {
  return (
    <div className="app-shell">
      {/* Traffic alert banner */}
      <TrafficAlertBanner />

      {/* Desktop only — hidden on mobile via CSS */}
      <Sidebar />

      <div className="app-main">
        <div className="page-content">
          {children}
        </div>

        {/* Mobile only — hidden on desktop via CSS */}
        <FAB />
        <BottomNav />
        <BackGuard />
      </div>

      {/* Desktop ≥1200px only */}
      <RightPanel />
    </div>
  )
}
